export default __webpack_public_path__ + "static/media/kavida-logo.5ef8cb11.png";